var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQuickbooksIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: 40,
    viewBox: "0 0 60 60",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30 0C13.4101 0 0 13.4091 0 30C0 46.5455 13.4101 60 30 60C46.5438 60 60 46.5909 60 30C59.9539 13.4091 46.5438 0 30 0ZM28.341 49.6364C25.9447 49.6364 24.0092 47.6818 24.0092 45.3182V22.6364H20C15.9447 22.6364 12.6728 25.9091 12.6728 29.9545C12.6728 34 15.9447 37.2727 20 37.2727H21.659V41.5909H20C13.5484 41.6364 8.34101 36.4091 8.34101 30C8.34101 23.5455 13.5484 18.3182 20 18.3182H28.341V49.6364ZM40 41.6364H31.659V10.3182C34.0553 10.3182 35.9908 12.2727 35.9908 14.6364V37.2727H40C44.0553 37.2727 47.3272 34 47.3272 29.9545C47.3272 25.9091 44.0553 22.6364 40 22.6364H38.341V18.3182H40C46.4516 18.3182 51.659 23.5455 51.659 30C51.659 36.4091 46.4055 41.6364 40 41.6364Z",
    fill: "#2CA01C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuickbooksIcon);
export default __webpack_public_path__ + "static/media/quickbooks-icon.53e5339ebe6027781e40cf9fa3a7a1e3.svg";
export { ForwardRef as ReactComponent };